export default "__VITE_ASSET__DBwgXilR__"